import { app, Component } from "modular-openscriptjs";
import { component as findComponent } from "modular-openscriptjs";

const h = app("h");
const $e = app("$e");

export default class UnAuthenticatedIndex extends Component {
  // Typewriter settings
  texts = [
    "Always Selling",
    "Regular Customers",
    "Growing Daily",
    "On Autopilot",
    "Everywhere",
  ];

  currentTextIndex = 0;
  charIndex = 0;
  isDeleting = false;
  typeSpeed = 100;
  deleteSpeed = 50;
  pauseTime = 2000;
  element = null;
  timeoutId = null;

  render(...args) {
    // Category data with Font Awesome icons
    const categories = [
      {
        icon: "fa-solid fa-box",
        title: "Daily Orders",
        description: "Receive orders without lifting a finger",
      },
      {
        icon: "fa-solid fa-globe",
        title: "Get Discovered",
        description: "Customers find you automatically",
      },
      {
        icon: "fa-solid fa-bolt",
        title: "No Website",
        description: "Be online without managing anything",
      },
      {
        icon: "fa-solid fa-repeat",
        title: "Subscriptions",
        description: "Turn buyers into repeat customers",
      },
      {
        icon: "fa-solid fa-user-check",
        title: "We Handle It",
        description: "Your online presence, fully managed",
      },
      {
        icon: "fa-solid fa-coins",
        title: "Consistent Income",
        description: "Earn predictably, not randomly",
      },
      {
        icon: "fa-solid fa-rocket",
        title: "Quick Setup",
        description: "Get started in minutes",
      },
      {
        icon: "fa-solid fa-location-dot",
        title: "Reach Nearby",
        description: "Connect with customers around you",
      },
      {
        icon: "fa-solid fa-brain",
        title: "No Skills Needed",
        description: "Anyone can use Carata",
      },
    ];

    const trustIndicators = [
      { text: "No Tech Skills Needed", icon: "fa-solid fa-check-circle" },
      { text: "Setup in Minutes", icon: "fa-solid fa-clock" },
      { text: "Built for Local Businesses", icon: "fa-solid fa-store" },
    ];

    return h.section(
      { class: "section-hero-premium light-theme position-relative" },

      // Background layers (Overlay)
      h.div({ class: "hero-premium-bg" }),
      h.div({ class: "hero-premium-mesh" }),

      // Main content
      h.div(
        { class: "container-xl hero-premium-content" },

        // Carata Badge
        h.div(
          {
            class:
              "badge rounded-pill px-3 py-2 mb-3 bg-white text-uppercase fw-bold shadow-sm d-inline-flex align-items-center gap-2",
            style: "color: #973e87; letter-spacing: 1px; font-size: 0.75rem;",
          },
          h.img({
            src: "/assets/images/logo.png",
            alt: "Carata Logo",
            style: "height: 16px; width: auto;",
          }),
          "Carata For Business",
        ),

        // Main headline with glow effect
        h.h1(
          { class: "hero-premium-title" },
          h.span({ class: "d-block" }, "Your Business, "),
          h.span(
            {
              class: "hero-premium-title-accent typewriter-text",
              id: "typewriter-target",
            },
            "Everywhere",
          ),
          h.span({ class: "typewriter-cursor" }, "|"),
        ),

        // Category cards grid
        h.div(
          { class: "hero-premium-categories" },
          h.div(
            { class: "hero-premium-categories-track" },
            // Original set
            ...categories.map((category) =>
              h.div(
                { class: "hero-premium-category-card" },
                h.div(
                  {
                    class: "hero-premium-category-icon-wrapper",
                  },
                  h.i({
                    class: `${category.icon} hero-premium-category-icon`,
                  }),
                ),
                h.h3({ class: "hero-premium-category-title" }, category.title),
                h.p(
                  {
                    class: "hero-premium-category-description",
                  },
                  category.description,
                ),
              ),
            ),
            // Duplicated set for seamless loop
            ...categories.map((category) =>
              h.div(
                { class: "hero-premium-category-card" },
                h.div(
                  {
                    class: "hero-premium-category-icon-wrapper",
                  },
                  h.i({
                    class: `${category.icon} hero-premium-category-icon`,
                  }),
                ),
                h.h3({ class: "hero-premium-category-title" }, category.title),
                h.p(
                  {
                    class: "hero-premium-category-description",
                  },
                  category.description,
                ),
              ),
            ),
          ),
        ),

        // CTA Section
        h.div(
          { class: "d-flex flex-column align-items-center gap-3 mt-4" },
          h.button(
            {
              class: "btn hero-premium-cta",
              onclick: `sendEvent('${$e.user.needs.authentication}')`,
              aria_label: "Add My Business",
            },
            "Add My Business",
          ),
          h.div(
            { class: "text-muted" },
            "or ",
            h.a(
              {
                href: "#",
                class: "text-decoration-none fw-bold",
                style: "color: #973e87;",
                onclick: `sendEvent('${$e.user.needs.authentication}')`,
              },
              "Login"
            )
          )
        ),

        // Trust indicators
        h.div(
          { class: "hero-premium-trust" },
          ...trustIndicators.map((indicator) =>
            h.div(
              { class: "hero-premium-trust-item" },
              h.i({
                class: `${indicator.icon} hero-premium-trust-icon`,
              }),
              h.span({ class: "hero-premium-trust-text" }, indicator.text),
            ),
          ),
        ),
      ),

      ...args,
    );
  }

  $_mounted_rendered_rerendered(componentId) {
    const component = findComponent(componentId);

    if (component) {
      component.element = document.getElementById("typewriter-target");
      clearTimeout(component.timeoutId);
      if (component.element) {
        // Start the typewriter effect
        component.timeoutId = setTimeout(
          () => component.type(),
          component.pauseTime,
        );
      }
    }
  }

  type() {
    if (!this.element) return;

    const currentFullText = this.texts[this.currentTextIndex];

    if (this.isDeleting) {
      // Deleting text
      this.element.textContent = currentFullText.substring(
        0,
        this.charIndex - 1,
      );
      this.charIndex--;
    } else {
      // Typing text
      this.element.textContent = currentFullText.substring(
        0,
        this.charIndex + 1,
      );
      this.charIndex++;
    }

    let typeSpeed = this.typeSpeed;

    if (this.isDeleting) {
      typeSpeed = this.deleteSpeed;
    }

    if (!this.isDeleting && this.charIndex === currentFullText.length) {
      // Finished typing sentence
      typeSpeed = this.pauseTime;
      this.isDeleting = true;
    } else if (this.isDeleting && this.charIndex === 0) {
      // Finished deleting sentence
      this.isDeleting = false;
      this.currentTextIndex++;
      if (this.currentTextIndex === this.texts.length) {
        this.currentTextIndex = 0;
      }
      typeSpeed = 500;
    }

    this.timeoutId = setTimeout(() => this.type(), typeSpeed);
  }

  cleanUp() {
    clearTimeout(this.timeoutId);
    this.element = null;
    this.timeoutId = null;
  }
}
